import { useState } from 'react';
import Modal from '../Modal';
import { presetData } from '../../data/presetData';
import { urlWithParams, useQuery } from '../Util';
import { useNavigate } from 'react-router-dom';

export default function Preset ({
	setModal,
	setOutputPreset,
	setCustomAspectRatioHeight,
	setCustomAspectRatioWidth,
	customAspectRatioHeight,
	customAspectRatioWidth
}) {
	const [customWidth, setCustomWidth] = useState(customAspectRatioWidth);
	const [customHeight, setCustomHeight] = useState(customAspectRatioHeight);

	const query = useQuery();
	const navigate = useNavigate();

	function doSetCustomAspectRatio (e) {
		if (0 === customHeight.length || 0 === customHeight.width) {
			alert('Please enter a correct width and height');
		}

		setCustomAspectRatioHeight(customHeight);
		setCustomAspectRatioWidth(customWidth);
		setModal('');

		setCustomHeight('');
		setCustomWidth('');
	}

	function dosetCustomHeight (e) {
		setCustomHeight(parseFloat(e.target.value));
	}

	function dosetCustomWidth (e) {
		setCustomWidth(parseFloat(e.target.value));
	}

	function doSetPreset (e) {
		const newPreset = e.target.dataset.preset;
		setOutputPreset(newPreset);
		setModal('');

		setCustomAspectRatioHeight(0);
		setCustomAspectRatioWidth(0);
		setCustomHeight('');
		setCustomWidth('');

		if (newPreset !== query.get('preset')) {
			navigate(urlWithParams({
				preset: '',
				width: '',
				custom: '',
			}));
		}
	}

	return (
		<Modal setModal={setModal}>
			<h2>Presets</h2>
			<div className="row">
				{presetData.map(preset => {
					return <div className="col-xs-12 col-md-6 col-lg-4 mb-3 d-flex align-items-stretch"
					            key={`modal-preset-${preset.id}`}
					>
						<div className="btn btn-outline-secondary w-100 flex-column pt-3"
						     onClick={doSetPreset}
						     data-preset={preset.id}
						>
							<div className="mx-auto shadow border border-dark-subtle bg-secondary-subtle"
							     style={{
								     height: '4em',
								     aspectRatio: preset.aspectRatio
							     }}
							/>
							<div className="fs-4">{preset.label}</div>
							{preset.width && (<small>
								({preset.width}px × {preset.height}px)
							</small>)}
						</div>
					</div>;
				})}
				<div className="col-10 mx-auto text-center border p-3 rounded">
					<label className="form-label" htmlFor="customWidth">Or enter a custom aspect ratio:</label>

					<div className="d-flex gap-1 justify-content-center align-items-center">
						<div>
							<input type="number" className="form-control text-center"
							       style={{
								       width: '5rem'
							       }}
							       id="customWidth"
							       value={customWidth}
							       onChange={dosetCustomWidth}
							       placeholder="1"
							       min=".1"
							       step=".01"
							/>
						</div>
						<div>/</div>
						<div>
							<input type="number" className="form-control text-center"
							       style={{
								       width: '5rem'
							       }}
							       value={customHeight}
							       onChange={dosetCustomHeight}
							       placeholder="1"
							       min=".1"
							       step=".01"
							/>
						</div>
						<button type="button" className="btn btn-secondary"
						        onClick={doSetCustomAspectRatio}
						>
							Set it
						</button>
					</div>
				</div>
			</div>
		</Modal>
	);
}